import React, { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import { getActiveSchoolId } from "./activeSchool";
import {
  listMySchools, listThiKhaoSat, createThiKhaoSat, getThiKhaoSat, updateThiKhaoSat, deleteThiKhaoSat,
  autoRoomsThiKhaoSat, autoInvigilationThiKhaoSat, saveScoresThiKhaoSat, renumberSbdThiKhaoSat,
} from "./happyschoolApi";
import { buildRoomListHtml, openPrintWindow, fmtDob } from "./thiKhaoSatPrint";
import ThiKhaoSatSheetModal from "./ThiKhaoSatSheetModal";
import TabBaoCao from "./ThiKhaoSatBaoCao";

// "Thi khảo sát" khối 12: 3 nhóm theo môn thi tốt nghiệp tự chọn (tự tìm qua
// PCCM — môn học 4 tiết/tuần), lịch thi, phòng thi, GV coi thi, nhập điểm, thống kê.
const TABS = [
  { key: "nhom", label: "👥 Nhóm lớp" },
  { key: "lich", label: "🗓️ Lịch thi" },
  { key: "phong", label: "🚪 Phòng thi" },
  { key: "coithi", label: "🧑‍🏫 GV coi thi" },
  { key: "kytiet", label: "✍️ Ký tiết coi thi" },
  { key: "xemdiem", label: "👁️ Xem điểm theo lớp" },
  { key: "diem", label: "✍️ Nhập điểm" },
  { key: "thongke", label: "📊 Thống kê" },
  { key: "baocao", label: "📋 Báo cáo chấm thi" },
];
const BUOI = { S: "Sáng", C: "Chiều" };
const fmtDate = (d) => { if (!d) return ""; const [y, m, dd] = String(d).split("-"); return `${dd}/${m}/${y}`; };
const DOW = ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
const dowOf = (d) => { const t = new Date(`${d}T00:00:00`); return Number.isNaN(t.getTime()) ? "" : DOW[t.getDay()]; };
const addDays = (d, n) => { const t = new Date(`${d}T00:00:00`); t.setDate(t.getDate() + n); return t.toISOString().slice(0, 10); };
const newId = () => `i${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
const sortItems = (sch) => Object.entries(sch || {}).sort((a, b) => `${a[1].date}${a[1].buoi === "S" ? 0 : 1}${a[1].start}`.localeCompare(`${b[1].date}${b[1].buoi === "S" ? 0 : 1}${b[1].start}`));
const slotOf = (it) => `${it.date}|${it.buoi}|${it.start}`;
const round2 = (x) => Math.round(x * 100) / 100;
// Tổng / Trung bình các môn ĐÃ CÓ điểm (không chờ đủ hết các môn): list = giá trị ô (chuỗi hoặc số, "" = chưa chấm).
const scoreStats = (list) => {
  const ns = list.map((v) => (String(v ?? "").trim() === "" ? null : Number(String(v).replace(",", ".")))).filter((n) => n !== null && Number.isFinite(n) && n >= 0 && n <= 10);
  if (!ns.length) return null;
  const sum = ns.reduce((a, b) => a + b, 0);
  return { sum: round2(sum), avg: round2(sum / ns.length), n: ns.length };
};
const fmtVn = (x) => String(x).replace(".", ",");
// (27/10/2026) đã gỡ mọi chức năng xuất Excel của "Thi khảo sát" (chỉ còn In). Theo yêu cầu, CHỈ tab
// "Thống kê" có lại nút Xuất Excel và chỉ owner/admin thấy (TabThongKe, isAdmin) — các nơi khác vẫn không xuất.
// Webview Zalo/Messenger/... trên iOS chặn tải file Blob nên báo người dùng mở bằng Safari.
function downloadWorkbook(wb, fileName) {
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua) && /Zalo|FBAN|FBAV|Instagram|Line\/|MicroMessenger/i.test(ua)) {
    window.alert("Trình duyệt trong ứng dụng (Zalo/Messenger/...) trên iPhone không cho tải file.\n\nBấm menu (⋮ hoặc ...) → \"Mở bằng trình duyệt\" (Safari) rồi xuất lại.");
    return;
  }
  const blob = new Blob([XLSX.write(wb, { bookType: "xlsx", type: "array" })], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = fileName;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

const HappySchoolThiKhaoSat = () => {
  const schoolId = getActiveSchoolId();
  const [exams, setExams] = useState([]);
  const [examId, setExamId] = useState("");
  const [data, setData] = useState(null); // {exam, subjects, groups, classes12, teachers, me}
  const [tab, setTab] = useState("nhom");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  // bản nháp đang sửa (chưa lưu) của từng phần
  const [draftGroups, setDraftGroups] = useState(null);
  const [draftSchedule, setDraftSchedule] = useState(null);
  const [draftRooms, setDraftRooms] = useState(null);
  const [draftInv, setDraftInv] = useState(null);

  const [myRole, setMyRole] = useState(null);
  useEffect(() => { if (schoolId) listMySchools().then((l) => setMyRole(((l || []).find((x) => x.id === schoolId) || {}).role || null)).catch(() => {}); }, [schoolId]);
  const loadList = () => listThiKhaoSat(schoolId).then((l) => { setExams(l || []); if (!examId && l && l.length) setExamId(l[0].id); }).catch((e) => setError(e.message));
  useEffect(() => { if (schoolId) loadList(); }, [schoolId]); // eslint-disable-line
  const reload = () => {
    if (!examId) { setData(null); return Promise.resolve(); }
    setLoading(true); setError("");
    return getThiKhaoSat(schoolId, examId)
      .then((d) => { setData(d); setDraftGroups(null); setDraftSchedule(null); setDraftRooms(null); setDraftInv(null); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(() => { reload(); }, [examId]); // eslint-disable-line

  const isAdmin = ["owner", "admin"].includes(data?.me?.role || myRole);
  const exam = data?.exam || {};
  // Người chấm được phân công (exam.graders) không phải quản trị vẫn phải thấy tab "Nhập điểm".
  const myGraded = data?.me?.staffId ? (() => { const v = (exam.graders || {})[data.me.staffId]; return Array.isArray(v) ? v : v ? Object.values(v) : []; })() : [];
  const subjByKey = useMemo(() => Object.fromEntries((data?.subjects || []).map((s) => [s.key, s])), [data]);
  const teacherById = useMemo(() => Object.fromEntries((data?.teachers || []).map((t) => [t.id, t])), [data]);
  const groupsOv = draftGroups || exam.groupOverrides || {};
  const groupOf = (c) => (groupsOv[c.id] === undefined || groupsOv[c.id] === null ? c.autoGroup : Number(groupsOv[c.id]));
  const classById = useMemo(() => Object.fromEntries((data?.classes12 || []).map((c) => [c.id, c])), [data]);
  const studentByKey = useMemo(() => {
    const m = {};
    (data?.classes12 || []).forEach((c) => c.students.forEach((s) => { m[`${c.id}|${s.id}`] = { ...s, classId: c.id, className: c.name }; }));
    return m;
  }, [data]);
  const schedule = draftSchedule || exam.schedule || {};
  const rooms = draftRooms || exam.rooms || {};
  const inv = draftInv || exam.invigilation || {};
  const roomList = useMemo(() => Object.entries(rooms).sort((a, b) => (a[1].order || 0) - (b[1].order || 0)), [rooms]);
  // SBD: CHỐT theo thí sinh trên server (exam.sbd, xem assignSbd ở
  // happyschool-api) — chia lại / chuyển phòng không đổi SBD. HS chưa có SBD
  // chốt (vd đang sửa nháp phòng, chưa lưu) tạm đánh số tiếp sau số lớn nhất.
  const sbdOf = useMemo(() => {
    const fixed = exam.sbd || {};
    const m = {};
    let n = Object.values(fixed).reduce((mx, v) => Math.max(mx, Number(v) || 0), 0);
    roomList.forEach(([rid, r]) => (r.students || []).forEach((k) => {
      const sbd = fixed[k] || String(++n).padStart(8, "0");
      m[k] = { sbd, roomId: rid };
    }));
    return m;
  }, [roomList, exam.sbd]);

  const run = async (fn, okMsg) => {
    setSaving(true); setError(""); setMsg("");
    try { await fn(); await reload(); if (okMsg) setMsg(okMsg); } catch (e) { setError(e.message); } finally { setSaving(false); }
  };

  if (!schoolId) return <div style={{ padding: 16 }}>Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link>.</div>;

  const createExam = () => {
    const name = window.prompt("Tên kỳ thi khảo sát (vd: Thi khảo sát lần 1 — Khối 12):", "Thi khảo sát lần 1 — Khối 12");
    if (!name) return;
    run(async () => { const r = await createThiKhaoSat(schoolId, name); await loadList(); setExamId(r.id); }, "Đã tạo kỳ thi.");
  };
  const renameExam = () => {
    const name = window.prompt("Đổi tên kỳ thi:", exam.name || "");
    if (!name) return;
    run(async () => { await updateThiKhaoSat(schoolId, examId, { name }); await loadList(); }, "Đã đổi tên.");
  };
  const removeExam = () => {
    if (!window.confirm(`Xoá kỳ thi "${exam.name}"? (lưu vào thùng rác trên server)`)) return;
    run(async () => { await deleteThiKhaoSat(schoolId, examId); setExamId(""); setData(null); const l = await listThiKhaoSat(schoolId); setExams(l || []); if (l && l.length) setExamId(l[0].id); }, "Đã xoá.");
  };

  return (
    <div style={{ padding: 16, maxWidth: 1400, margin: "0 auto" }}>
      <h2 style={{ marginTop: 0 }}>📝 Thi khảo sát — Khối 12</h2>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
        <select value={examId} onChange={(e) => setExamId(e.target.value)} style={sel}>
          {!exams.length && <option value="">— Chưa có kỳ thi —</option>}
          {exams.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
        </select>
        {isAdmin && <button type="button" onClick={createExam} style={btn} disabled={saving}>+ Tạo kỳ thi</button>}
        {isAdmin && examId && <button type="button" onClick={renameExam} style={btnLight} disabled={saving}>Đổi tên</button>}
        {isAdmin && examId && <button type="button" onClick={removeExam} style={btnDanger} disabled={saving}>Xoá</button>}
        {(loading || saving) && <span style={{ color: "#b45309", fontSize: 13 }}>Đang xử lý...</span>}
      </div>
      {error && <p style={errStyle}>{error}</p>}
      {msg && <p style={okStyle}>{msg}</p>}
      {!data ? (
        <p style={{ color: "#6b7280" }}>{examId ? "Đang tải..." : isAdmin ? "Tạo 1 kỳ thi để bắt đầu." : "Nhà trường chưa tạo kỳ thi khảo sát nào."}</p>
      ) : (
        <>
          <StudentSearch {...{ data, rooms, roomList, schedule, sbdOf, subjByKey }} />
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 14 }}>
            {TABS.filter((t) => isAdmin || (t.key === "diem" && myGraded.length > 0) || !["diem", "thongke", "baocao"].includes(t.key)).map((t) => <button key={t.key} type="button" onClick={() => setTab(t.key)} style={tab === t.key ? tabOn : tabOff}>{t.label}</button>)}
          </div>
          {tab === "nhom" && <TabNhom {...{ data, groupOf, groupsOv, setDraftGroups, draftGroups, isAdmin, saving, run, schoolId, examId }} />}
          {tab === "lich" && <TabLich {...{ data, schedule, setDraftSchedule, draftSchedule, isAdmin, saving, run, schoolId, examId, subjByKey }} />}
          {tab === "phong" && <TabPhong {...{ data, exam, rooms, roomList, setDraftRooms, draftRooms, isAdmin, saving, run, schoolId, examId, studentByKey, sbdOf, groupOf }} />}
          {tab === "coithi" && <TabCoiThi {...{ data, schedule, roomList, inv, setDraftInv, draftInv, isAdmin, saving, run, schoolId, examId, subjByKey, teacherById }} />}
          {tab === "kytiet" && <TabKyTiet {...{ data, exam, schedule, roomList, inv, teacherById, subjByKey, isAdmin }} />}
          {tab === "xemdiem" && <TabXemDiem {...{ data, exam, groupOf, schoolId, examId, subjByKey, sbdOf, rooms, isAdmin, scoreAccess: data.scoreAccess }} />}
          {tab === "diem" && <TabDiem {...{ data, exam, groupOf, isAdmin, saving, run, schoolId, examId, subjByKey, sbdOf, rooms }} />}
          {tab === "thongke" && <TabThongKe {...{ data, exam, groupOf, subjByKey, classById, isAdmin }} />}
          {tab === "baocao" && <TabBaoCao {...{ data, exam, schoolId, examId, roomList, sbdOf, studentByKey, subjByKey, groupOf, classById, isAdmin }} />}
        </>
      )}
    </div>
  );
};

const cmpViName = (a, b) => { const k = (n) => { const p = String(n || "").trim().split(/\s+/); return `${p[p.length - 1] || ""} ${p.slice(0, -1).join(" ")}`; }; return k(a).localeCompare(k(b), "vi"); };
const NGHE_BG = "#ffedd5"; // tô màu GV Nghề (bảng phân GV coi thi)
const NGHE_FG = "#c2410c";

// ---------- Nhóm lớp ----------
// ---------- Tìm kiếm học sinh: gõ tên (không dấu cũng được) / lớp / SBD -> thông tin HS, phòng thi, địa điểm, lịch thi ----------
const normVi = (x) => String(x || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/gi, "d").toLowerCase().replace(/\s+/g, " ").trim();
function StudentSearch({ data, rooms, roomList, schedule, sbdOf, subjByKey }) {
  const [q, setQ] = useState("");
  const all = useMemo(() => {
    const roomOfKey = {};
    roomList.forEach(([rid, r]) => (r.students || []).forEach((k) => { roomOfKey[k] = rid; }));
    const list = [];
    (data?.classes12 || []).forEach((c) => (c.students || []).forEach((st) => {
      const key = `${c.id}|${st.id}`;
      list.push({ key, st, className: c.name, roomId: roomOfKey[key] || null, sbd: (sbdOf[key] || {}).sbd || "", n: normVi(st.name) });
    }));
    return list;
  }, [data, roomList, sbdOf]);
  const nq = normVi(q);
  const results = useMemo(() => {
    if (nq.length < 2) return [];
    return all.filter((x) => x.n.includes(nq) || normVi(x.className) === nq || x.sbd === q.trim())
      .sort((a, b) => a.className.localeCompare(b.className, "vi", { numeric: true }) || a.n.localeCompare(b.n, "vi"));
  }, [all, nq, q]);
  const items = sortItems(schedule);
  const examsOf = (group) => items.filter(([, it]) => (it.groups || []).map(Number).includes(Number(group)));
  return (
    <div style={{ margin: "0 0 14px", padding: "10px 12px", border: "1px solid #e5e7eb", borderRadius: 10, background: "#fafafa" }}>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="🔎 Tìm học sinh: gõ tên (vd: bao yen), lớp (12A4) hoặc số báo danh"
        style={{ width: "100%", maxWidth: 520, padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box" }} />
      {nq.length >= 2 && (
        <div style={{ marginTop: 8 }}>
          {!results.length ? <div style={{ fontSize: 13, color: "#6b7280" }}>Không tìm thấy học sinh nào khớp “{q}”.</div> : (
            <>
              <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>{results.length} kết quả{results.length > 50 ? " (hiện 50 đầu tiên — gõ cụ thể hơn)" : ""}</div>
              <div style={{ overflowX: "auto" }}>
                <table style={{ ...tbl, width: "auto" }}>
                  <thead><tr>{["Họ và tên", "Lớp", "Ngày sinh", "SBD", "Phòng thi", "Địa điểm", "Nhóm", "Lịch thi"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {results.slice(0, 50).map((x) => {
                      const r = x.roomId ? rooms[x.roomId] : null;
                      return (
                        <tr key={x.key}>
                          <td style={{ ...tdB, textAlign: "left" }}>{x.st.name}</td>
                          <td style={td}>{x.className}</td>
                          <td style={td}>{fmtDob(x.st.dob) || "—"}</td>
                          <td style={tdB}>{r ? x.sbd : "—"}</td>
                          <td style={{ ...tdB, color: r ? "#0f766e" : "#dc2626" }}>{r ? r.name : "Chưa xếp phòng"}</td>
                          <td style={tdB}>{r ? (r.location || "—") : "—"}</td>
                          <td style={td}>{r ? r.group : "—"}</td>
                          <td style={{ ...td, textAlign: "left", fontSize: 12 }}>{r ? examsOf(r.group).map(([iid, it]) => <div key={iid}>{dowOf(it.date)} {fmtDate(it.date)} · {BUOI[it.buoi]} {it.start} · <b>{subjByKey[it.subjectKey]?.label}</b></div>) : "—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

function TabNhom({ data, groupOf, groupsOv, setDraftGroups, draftGroups, isAdmin, saving, run, schoolId, examId }) {
  const setG = (cid, v) => setDraftGroups({ ...groupsOv, [cid]: v === "auto" ? null : Number(v) });
  const groupsSummary = [1, 2, 3].map((g) => {
    const cls = data.classes12.filter((c) => groupOf(c) === g);
    return { g, cls, hs: cls.reduce((s, c) => s + c.students.length, 0) };
  });
  return (
    <div>
      <p style={hint}>Nhóm tự tìm theo Phân công chuyên môn: lớp học <b>Địa lý</b> 4 tiết/tuần → Nhóm 1, <b>GDKT&PL</b> 4 tiết → Nhóm 2, <b>Công nghệ</b> 4 tiết → Nhóm 3. Có thể chọn lại tay cho từng lớp (chỉ áp dụng cho kỳ thi này).</p>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
        {groupsSummary.map(({ g, cls, hs }) => (
          <div key={g} style={card}>
            <div style={{ fontWeight: 700 }}>{data.groups[g].label}: {data.groups[g].subjects.map((k) => data.subjects.find((s) => s.key === k)?.label).join(", ")}</div>
            <div style={{ fontSize: 13, color: "#374151", marginTop: 4 }}>{cls.length} lớp · {hs} HS</div>
            <div style={{ fontSize: 13, color: "#0f766e", marginTop: 4 }}>{cls.map((c) => `${c.name}(${c.students.length})`).join(", ") || "—"}</div>
          </div>
        ))}
      </div>
      <table style={tbl}>
        <thead><tr><th style={th}>Lớp</th><th style={th}>Sĩ số</th><th style={th}>Địa lý (tiết)</th><th style={th}>GDKT&PL (tiết)</th><th style={th}>Công nghệ (tiết)</th><th style={th}>Nhóm theo PCCM</th><th style={th}>Nhóm thi</th></tr></thead>
        <tbody>
          {data.classes12.map((c) => {
            const ov = groupsOv[c.id];
            return (
              <tr key={c.id}>
                <td style={tdB}>{c.name}</td>
                <td style={td}>{c.students.length}</td>
                <td style={td}>{c.electivePeriods.dia}</td><td style={td}>{c.electivePeriods.gdkt}</td><td style={td}>{c.electivePeriods.cn}</td>
                <td style={td}>{c.autoGroup ? `Nhóm ${c.autoGroup}` : <span style={{ color: "#dc2626" }}>Không xác định</span>}</td>
                <td style={td}>
                  {isAdmin ? (
                    <select value={ov === undefined || ov === null ? "auto" : String(ov)} onChange={(e) => setG(c.id, e.target.value)} style={sel}>
                      <option value="auto">Theo PCCM{c.autoGroup ? ` (Nhóm ${c.autoGroup})` : ""}</option>
                      <option value="1">Nhóm 1</option><option value="2">Nhóm 2</option><option value="3">Nhóm 3</option><option value="0">Không thi</option>
                    </select>
                  ) : (groupOf(c) ? `Nhóm ${groupOf(c)}` : "Không thi")}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {isAdmin && draftGroups && (
        <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
          <button type="button" style={btn} disabled={saving} onClick={() => run(() => updateThiKhaoSat(schoolId, examId, { groupOverrides: draftGroups }), "Đã lưu nhóm lớp. Nhớ chia lại phòng thi nếu đã chia.")}>💾 Lưu nhóm</button>
          <button type="button" style={btnLight} onClick={() => setDraftGroups(null)}>Huỷ</button>
        </div>
      )}
    </div>
  );
}

// ---------- Lịch thi ----------
function TabLich({ data, schedule, setDraftSchedule, draftSchedule, isAdmin, saving, run, schoolId, examId, subjByKey }) {
  const [startDate, setStartDate] = useState(new Date(Date.now() + 7 * 864e5).toISOString().slice(0, 10));
  const items = sortItems(schedule);
  const setItem = (id, patch) => setDraftSchedule({ ...schedule, [id]: { ...schedule[id], ...patch } });
  const delItem = (id) => { const n = { ...schedule }; delete n[id]; setDraftSchedule(n); };
  const addItem = () => setDraftSchedule({ ...schedule, [newId()]: { date: startDate, buoi: "S", start: "07:30", minutes: 90, subjectKey: "toan", groups: [1, 2, 3] } });
  const sample = () => {
    if (items.length && !window.confirm("Thay toàn bộ lịch hiện tại bằng lịch mẫu?")) return;
    const d2 = addDays(startDate, 1);
    const mk = (date, buoi, start, subjectKey, groups) => ({ date, buoi, start, minutes: subjByKey[subjectKey]?.minutes || 50, subjectKey, groups });
    setDraftSchedule({
      [newId()]: mk(startDate, "S", "07:30", "van", [1, 2, 3]),
      [newId()]: mk(startDate, "C", "14:00", "toan", [1, 2, 3]),
      [newId()]: mk(d2, "S", "07:30", "su", [1, 2, 3]),
      [newId()]: mk(d2, "S", "09:00", "dia", [1]),
      [newId()]: mk(d2, "S", "09:00", "gdkt", [2]),
      [newId()]: mk(d2, "S", "09:00", "cn", [3]),
    });
  };
  const toggleGroup = (id, g) => { const cur = (schedule[id].groups || []).map(Number); setItem(id, { groups: cur.includes(g) ? cur.filter((x) => x !== g) : [...cur, g].sort() }); };
  return (
    <div>
      <p style={hint}>Mỗi dòng là 1 ca thi. Các ca cùng ngày + buổi + giờ (vd 3 môn tự chọn của 3 nhóm) thi cùng lúc — GV coi thi không bị xếp trùng giữa các ca này.</p>
      {isAdmin && (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
          <span style={{ fontSize: 13 }}>Ngày thi đầu tiên:</span>
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} style={sel} />
          <button type="button" style={btnLight} onClick={sample}>⚡ Tạo lịch mẫu (2 ngày)</button>
          <button type="button" style={btnLight} onClick={addItem}>+ Thêm ca thi</button>
        </div>
      )}
      <table style={tbl}>
        <thead><tr><th style={th}>Ngày</th><th style={th}>Thứ</th><th style={th}>Buổi</th><th style={th}>Giờ bắt đầu</th><th style={th}>Thời gian (phút)</th><th style={th}>Môn</th><th style={th}>Nhóm thi</th>{isAdmin && <th style={th}></th>}</tr></thead>
        <tbody>
          {!items.length && <tr><td style={td} colSpan={8}>Chưa có ca thi.</td></tr>}
          {items.map(([id, it]) => (
            <tr key={id}>
              <td style={td}>{isAdmin ? <input type="date" value={it.date || ""} onChange={(e) => setItem(id, { date: e.target.value })} style={sel} /> : fmtDate(it.date)}</td>
              <td style={td}>{dowOf(it.date)}</td>
              <td style={td}>{isAdmin ? <select value={it.buoi} onChange={(e) => setItem(id, { buoi: e.target.value })} style={sel}><option value="S">Sáng</option><option value="C">Chiều</option></select> : BUOI[it.buoi]}</td>
              <td style={td}>{isAdmin ? <input type="time" value={it.start || ""} onChange={(e) => setItem(id, { start: e.target.value })} style={sel} /> : it.start}</td>
              <td style={td}>{isAdmin ? <input type="number" min={15} max={240} value={it.minutes || ""} onChange={(e) => setItem(id, { minutes: Number(e.target.value) })} style={{ ...sel, width: 70 }} /> : it.minutes}</td>
              <td style={td}>{isAdmin ? <select value={it.subjectKey} onChange={(e) => setItem(id, { subjectKey: e.target.value, minutes: subjByKey[e.target.value]?.minutes || it.minutes })} style={sel}>{data.subjects.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}</select> : subjByKey[it.subjectKey]?.label}</td>
              <td style={td}>{[1, 2, 3].map((g) => (
                <label key={g} style={{ marginRight: 8, fontSize: 13, whiteSpace: "nowrap" }}>
                  <input type="checkbox" disabled={!isAdmin} checked={(it.groups || []).map(Number).includes(g)} onChange={() => toggleGroup(id, g)} /> N{g}
                </label>))}</td>
              {isAdmin && <td style={td}><button type="button" style={btnDangerSm} onClick={() => delItem(id)}>Xoá</button></td>}
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
        {isAdmin && draftSchedule && <button type="button" style={btn} disabled={saving} onClick={() => run(() => updateThiKhaoSat(schoolId, examId, { schedule: draftSchedule }), "Đã lưu lịch thi.")}>💾 Lưu lịch thi</button>}
        {isAdmin && draftSchedule && <button type="button" style={btnLight} onClick={() => setDraftSchedule(null)}>Huỷ</button>}
      </div>
    </div>
  );
}

// ---------- Phòng thi ----------
const DEFAULT_PRINT_TITLE = "DANH SÁCH HỌC SINH LỚP 12 THI KSCL LẦN 1 NĂM HỌC 2026-2027";
function TabPhong({ data, exam, rooms, roomList, setDraftRooms, draftRooms, isAdmin, saving, run, schoolId, examId, studentByKey, sbdOf, groupOf }) {
  const [size, setSize] = useState(exam.roomSize || 24);
  const [open, setOpen] = useState({});
  const [printTitle, setPrintTitle] = useState(exam.printTitle || DEFAULT_PRINT_TITLE);
  const [printRoom, setPrintRoom] = useState("");
  const [sbdPrefix, setSbdPrefix] = useState(exam.sbdPrefix || "2610");
  const setRoom = (rid, patch) => setDraftRooms({ ...rooms, [rid]: { ...rooms[rid], ...patch } });
  // (26/10/2026) Danh sách phòng thi KHÔNG hiện điểm — điểm chỉ xem theo lớp (tab "Xem điểm theo lớp").
  const totalHs = data.classes12.filter((c) => groupOf(c)).reduce((s, c) => s + c.students.length, 0);
  const inRooms = roomList.reduce((s, [, r]) => s + (r.students || []).length, 0);
  const autoRooms = () => {
    if (roomList.length && !window.confirm("Chia lại phòng thi sẽ XOÁ phân công GV coi thi hiện có. Tiếp tục?")) return;
    run(() => autoRoomsThiKhaoSat(schoolId, examId, Number(size)), "Đã chia phòng thi.");
  };
  const renumberSbd = () => {
    if (!/^\d{4}$/.test(sbdPrefix)) { window.alert("Tiền tố SBD phải gồm đúng 4 chữ số (vd 2610)."); return; }
    if (!window.confirm(`Tạo lại SBD cho TẤT CẢ thí sinh theo dạng ${sbdPrefix} + số phòng (2 số) + số chỗ (2 số), vd Phòng 16 chỗ 1 = ${sbdPrefix}1601?\n\nSBD cũ đã in / phát cho HS sẽ KHÔNG còn đúng — phải in lại danh sách phòng thi.`)) return;
    run(() => renumberSbdThiKhaoSat(schoolId, examId, sbdPrefix), "Đã tạo lại SBD.");
  };
  // In danh sách HS theo phòng (mẫu giấy nhà trường, mỗi phòng 1 trang A4).
  const printRooms = () => {
    const list = roomList.filter(([rid]) => !printRoom || rid === printRoom).map(([, r]) => ({
      name: r.name,
      students: (r.students || []).map((k) => { const s = studentByKey[k] || {}; return { sbd: sbdOf[k]?.sbd, name: s.name || "", dob: fmtDob(s.dob), gender: s.gender, className: s.className }; }),
    }));
    openPrintWindow(buildRoomListHtml({ title: printTitle, rooms: list }));
    savePrintTitle();
  };
  // Nhớ tiêu đề in cho lần sau (theo kỳ thi) — chỉ admin mới lưu được.
  const savedTitleRef = React.useRef(exam.printTitle || DEFAULT_PRINT_TITLE);
  const savePrintTitle = () => {
    const t = printTitle.trim();
    if (!isAdmin || !t || t === savedTitleRef.current) return;
    savedTitleRef.current = t;
    updateThiKhaoSat(schoolId, examId, { printTitle: t }).catch(() => {});
  };
  return (
    <div>
      <p style={hint}>Tự chia: gộp HS các lớp cùng nhóm, xếp theo Tên (A→Z), chia đều mỗi phòng ~{size} HS. Số báo danh (SBD) 8 số = tiền tố 4 số + số phòng 2 số (lấy từ tên phòng) + số chỗ 2 số, vd 26101601 (bấm "🔢 Tạo lại SBD"). SBD CHỐT theo thí sinh: chia lại / chuyển phòng không đổi SBD; HS mới nhận chỗ tiếp theo trong phòng của mình. HS ngồi cố định 1 phòng cho mọi môn.</p>
      {isAdmin && (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
          <span style={{ fontSize: 13 }}>Số HS tối đa/phòng:</span>
          <input type="number" min={5} max={60} value={size} onChange={(e) => setSize(e.target.value)} style={{ ...sel, width: 70 }} />
          <button type="button" style={btn} disabled={saving} onClick={autoRooms}>⚡ Tự chia phòng thi</button>
          {roomList.length > 0 && (
            <>
              <span style={{ fontSize: 13, marginLeft: 8 }}>Tiền tố SBD:</span>
              <input value={sbdPrefix} maxLength={4} onChange={(e) => setSbdPrefix(e.target.value.replace(/\D/g, ""))} style={{ ...sel, width: 60 }} />
              <button type="button" style={btn} disabled={saving || !!draftRooms} onClick={renumberSbd} title={draftRooms ? "Lưu phòng thi trước" : "SBD = tiền tố + số phòng + số chỗ"}>🔢 Tạo lại SBD</button>
            </>
          )}
        </div>
      )}
      <p style={{ fontSize: 13 }}>Tổng HS dự thi: <b>{totalHs}</b> · Đã xếp phòng: <b>{inRooms}</b> · Số phòng: <b>{roomList.length}</b>{inRooms !== totalHs && roomList.length > 0 && <span style={{ color: "#dc2626" }}> — danh sách HS/nhóm đã thay đổi, nên chia lại phòng</span>}</p>
      <table style={tbl}>
        <thead><tr><th style={th}>Phòng</th><th style={th}>Địa điểm</th><th style={th}>Nhóm</th><th style={th}>Số HS</th><th style={th}>SBD</th><th style={th}>Lớp</th><th style={th}></th></tr></thead>
        <tbody>
          {!roomList.length && <tr><td style={td} colSpan={7}>Chưa chia phòng.</td></tr>}
          {roomList.map(([rid, r]) => {
            const st = r.students || [];
            const byClass = {}; st.forEach((k) => { const n = studentByKey[k]?.className || "?"; byClass[n] = (byClass[n] || 0) + 1; });
            return (
              <React.Fragment key={rid}>
                <tr>
                  <td style={tdB}>{isAdmin ? <input value={r.name || ""} onChange={(e) => setRoom(rid, { name: e.target.value })} style={{ ...sel, width: 110 }} /> : r.name}</td>
                  <td style={td}>{isAdmin ? <input value={r.location || ""} placeholder="vd: Phòng 12A1" onChange={(e) => setRoom(rid, { location: e.target.value })} style={{ ...sel, width: 140 }} /> : r.location}</td>
                  <td style={td}>Nhóm {r.group}</td>
                  <td style={td}>{st.length}</td>
                  <td style={td}>{st.length ? `${sbdOf[st[0]]?.sbd} – ${sbdOf[st[st.length - 1]]?.sbd}` : ""}</td>
                  <td style={{ ...td, fontSize: 12 }}>{Object.entries(byClass).map(([n, c]) => `${n}: ${c}`).join(", ")}</td>
                  <td style={td}><button type="button" style={btnLightSm} onClick={() => setOpen((o) => ({ ...o, [rid]: !o[rid] }))}>{open[rid] ? "Ẩn" : "Danh sách"}</button></td>
                </tr>
                {open[rid] && (
                  <tr><td colSpan={7} style={{ ...td, background: "#f9fafb" }}>
                    <table style={{ ...tbl, width: "auto" }}>
                      <thead><tr><th style={th}>STT</th><th style={th}>SBD</th><th style={th}>Họ và tên</th><th style={th}>Ngày sinh</th><th style={th}>Lớp</th></tr></thead>
                      <tbody>{st.map((k, i) => { const s = studentByKey[k] || {}; return <tr key={k}><td style={td}>{i + 1}</td><td style={td}>{sbdOf[k]?.sbd}</td><td style={{ ...td, textAlign: "left" }}>{s.name || <i style={{ color: "#dc2626" }}>HS không còn trong danh sách</i>}</td><td style={td}>{fmtDob(s.dob)}</td><td style={td}>{s.className}</td></tr>; })}</tbody>
                    </table>
                  </td></tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
        {isAdmin && draftRooms && <button type="button" style={btn} disabled={saving} onClick={() => run(() => updateThiKhaoSat(schoolId, examId, { rooms: draftRooms }), "Đã lưu phòng thi.")}>💾 Lưu tên/địa điểm phòng</button>}
        {isAdmin && draftRooms && <button type="button" style={btnLight} onClick={() => setDraftRooms(null)}>Huỷ</button>}
      </div>
      {roomList.length > 0 && (
        <div style={{ marginTop: 10, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <span style={{ fontSize: 13 }}>Tiêu đề in:</span>
          <input value={printTitle} onChange={(e) => setPrintTitle(e.target.value)} onBlur={savePrintTitle} style={{ ...sel, flex: "1 1 360px", minWidth: 240 }} />
          <select value={printRoom} onChange={(e) => setPrintRoom(e.target.value)} style={sel}>
            <option value="">Tất cả phòng ({roomList.length})</option>
            {roomList.map(([rid, r]) => <option key={rid} value={rid}>{r.name}</option>)}
          </select>
          <button type="button" style={btn} onClick={printRooms} disabled={!!draftRooms} title={draftRooms ? "Lưu phòng thi trước" : ""}>🖨 In danh sách phòng thi</button>
        </div>
      )}
    </div>
  );
}

// ---------- GV coi thi ----------
function TabCoiThi({ data, schedule, roomList, inv, setDraftInv, draftInv, isAdmin, saving, run, schoolId, examId, subjByKey, teacherById }) {
  const [perRoom, setPerRoom] = useState(1);
  const [view, setView] = useState("all"); // "all" | "mine" — Phòng thi của tôi
  const items = sortItems(schedule);
  const setCell = (itemId, roomId, idx, tid) => {
    const cur = [...(((inv[itemId] || {})[roomId]) || [])];
    cur[idx] = tid || null;
    setDraftInv({ ...inv, [itemId]: { ...(inv[itemId] || {}), [roomId]: cur.filter((x, i) => x || i < cur.length - 1) } });
  };
  // cảnh báo: GV trùng ca
  const warnOf = (itemId, tid) => {
    if (!tid) return "";
    const it = schedule[itemId];
    let n = 0;
    items.forEach(([iid, it2]) => { if (slotOf(it2) !== slotOf(it)) return; Object.values(inv[iid] || {}).forEach((arr) => (arr || []).forEach((x) => { if (x === tid) n++; })); });
    return n > 1 ? "Trùng ca" : "";
  };
  const load = {}; Object.values(inv).forEach((m) => Object.values(m || {}).forEach((arr) => (arr || []).forEach((x) => { if (x) load[x] = (load[x] || 0) + 1; })));
  // Tiết coi thi (tính công): mỗi ngày coi cả ngày = 8 tiết, chỉ sáng = 5 tiết, chỉ chiều = 3 tiết (19/10/2026).
  const buoiByDay = {}; // tid -> { date: Set("S"|"C") }
  items.forEach(([iid, it]) => Object.values(inv[iid] || {}).forEach((arr) => (arr || []).forEach((x) => {
    if (!x) return; const m = (buoiByDay[x] = buoiByDay[x] || {}); (m[it.date] = m[it.date] || new Set()).add(it.buoi);
  })));
  const tietOfDay = (set) => (set.has("S") && set.has("C") ? 8 : set.has("S") ? 5 : set.has("C") ? 3 : 0);
  const tietCoiThi = (tid) => Object.values(buoiByDay[tid] || {}).reduce((a, set) => a + tietOfDay(set), 0);
  const buoiLabel = (tid) => Object.entries(buoiByDay[tid] || {}).sort().map(([d, set]) => `${fmtDate(d)}: ${set.has("S") && set.has("C") ? "Cả ngày" : set.has("S") ? "Sáng" : "Chiều"}`).join("; ");
  const isTGT = (t) => /thỉnh giảng/i.test(String(t.employmentType || "").normalize("NFC"));
  const sortCoi = (a, b) => tietCoiThi(b.id) - tietCoiThi(a.id) || cmpViName(a.name, b.name);
  const coHuuList = data.teachers.filter((t) => load[t.id] && !isTGT(t)).sort(sortCoi);
  const tgList = data.teachers.filter((t) => load[t.id] && isTGT(t)).sort(sortCoi);
  const short = items.reduce((s, [iid, it]) => s + roomList.filter(([, r]) => (it.groups || []).map(Number).includes(Number(r.group))).reduce((a, [rid]) => a + Math.max(0, perRoom - (((inv[iid] || {})[rid]) || []).filter(Boolean).length), 0), 0);
  if (!items.length || !roomList.length) return <p style={hint}>Cần có <b>Lịch thi</b> và <b>Phòng thi</b> trước khi phân GV coi thi.</p>;
  const myId = data.me?.staffId;
  const mine = myId ? items.flatMap(([iid, it]) => roomList.filter(([rid]) => (((inv[iid] || {})[rid]) || []).includes(myId)).map(([rid, r]) => ({ iid, it, r }))) : [];
  const viewBar = (
    <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
      <button type="button" onClick={() => setView("all")} style={view === "all" ? tabOn : tabOff}>📋 Tất cả phòng</button>
      <button type="button" onClick={() => setView("mine")} style={view === "mine" ? tabOn : tabOff}>🙋 Phòng thi của tôi{myId ? ` (${mine.length})` : ""}</button>
    </div>
  );
  if (view === "mine") {
    return (
      <div>
        {viewBar}
        {!myId ? <p style={hint}>Tài khoản này chưa liên kết hồ sơ giáo viên nên không xác định được phòng thi của bạn.</p>
          : !mine.length ? <p style={hint}>Bạn chưa được phân coi thi phòng nào trong kỳ thi này.</p> : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ ...tbl, width: "auto" }}>
              <thead><tr>{["STT", "Ngày", "Buổi", "Giờ", "Môn", "Phòng", "Địa điểm", "Số thí sinh", "Coi thi cùng"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
              <tbody>
                {mine.map(({ iid, it, r }, i) => {
                  const rid = (roomList.find(([, rr]) => rr === r) || [])[0];
                  const others = ((((inv[iid] || {})[rid]) || []).filter((x) => x && x !== myId)).map((x) => teacherById[x]?.name || x);
                  return (
                    <tr key={iid + rid}>
                      <td style={td}>{i + 1}</td>
                      <td style={td}>{dowOf(it.date)} {fmtDate(it.date)}</td>
                      <td style={td}>{BUOI[it.buoi]}</td>
                      <td style={td}>{it.start}{it.minutes ? ` (${it.minutes}')` : ""}</td>
                      <td style={tdB}>{subjByKey[it.subjectKey]?.label}</td>
                      <td style={tdB}>{r.name}</td>
                      <td style={td}>{r.location || "—"}</td>
                      <td style={td}>{(r.students || []).length}</td>
                      <td style={{ ...td, textAlign: "left" }}>{others.join(", ") || "—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
  return (
    <div>
      {viewBar}
      {myId && (
        <div style={{ ...card, marginBottom: 12, maxWidth: 700 }}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>📌 Lịch coi thi của tôi ({mine.length} ca)</div>
          {!mine.length ? <div style={{ fontSize: 13, color: "#6b7280" }}>Bạn chưa được phân coi thi.</div> : mine.map(({ iid, it, r }) => (
            <div key={iid + r.name} style={{ fontSize: 13 }}>{dowOf(it.date)} {fmtDate(it.date)} · {BUOI[it.buoi]} {it.start} · {subjByKey[it.subjectKey]?.label} · <b>{r.name}</b>{r.location ? ` (${r.location})` : ""}</div>
          ))}
        </div>
      )}
      <p style={hint}>Tự phân (chỉ GV cơ hữu, không lấy GV Nghề): mỗi ca xếp 1 GV cho mọi phòng trước, còn GV mới xếp GV thứ 2 (tối đa {perRoom} GV/phòng), chia đều số lượt; 1 GV không coi 2 phòng cùng lúc. GV đã nghỉ việc không có trong danh sách. Ô đỏ = cảnh báo trùng ca. <span style={{ background: NGHE_BG, color: NGHE_FG, padding: "1px 6px", borderRadius: 4, fontWeight: 600 }}>Tô cam = GV Nghề</span></p>
      {isAdmin && (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
          <span style={{ fontSize: 13 }}>Số GV/phòng:</span>
          <select value={perRoom} onChange={(e) => setPerRoom(Number(e.target.value))} style={sel}><option value={1}>1</option><option value={2}>2</option><option value={3}>3</option></select>
          <button type="button" style={btn} disabled={saving} onClick={() => { if (Object.keys(inv).length && !window.confirm("Phân lại sẽ thay toàn bộ phân công hiện có. Tiếp tục?")) return; run(() => autoInvigilationThiKhaoSat(schoolId, examId, perRoom), "Đã phân GV coi thi."); }}>⚡ Tự phân GV coi thi</button>
          {short > 0 && <span style={{ color: "#dc2626", fontSize: 13 }}>Còn thiếu {short} lượt GV (không đủ GV rảnh)</span>}
        </div>
      )}
      <div style={{ overflowX: "auto" }}>
        <table style={tbl}>
          <thead><tr><th style={{ ...th, position: "sticky", left: 0, zIndex: 2 }}>Phòng</th>{items.map(([iid, it]) => <th key={iid} style={th}>{fmtDate(it.date)} {BUOI[it.buoi]} {it.start}<br />{subjByKey[it.subjectKey]?.label} ({(it.groups || []).map((g) => `N${g}`).join(",")})</th>)}</tr></thead>
          <tbody>
            {roomList.map(([rid, r]) => (
              <tr key={rid}>
                <td style={{ ...tdB, position: "sticky", left: 0, background: "#fff", zIndex: 1 }}>{r.name}<div style={{ fontSize: 11, color: "#6b7280" }}>Nhóm {r.group}{r.location ? ` · ${r.location}` : ""}</div></td>
                {items.map(([iid, it]) => {
                  if (!(it.groups || []).map(Number).includes(Number(r.group))) return <td key={iid} style={{ ...td, background: "#f3f4f6" }}></td>;
                  const arr = ((inv[iid] || {})[rid]) || [];
                  const n = Math.max(perRoom, arr.length);
                  return (
                    <td key={iid} style={td}>
                      {Array.from({ length: n }).map((_, i) => {
                        const w = warnOf(iid, arr[i]);
                        const nghe = !!teacherById[arr[i]]?.gvNghe;
                        return isAdmin ? (
                          <select key={i} value={arr[i] || ""} onChange={(e) => setCell(iid, rid, i, e.target.value)} style={{ ...sel, display: "block", marginBottom: 2, width: 170, fontSize: 12, borderColor: w ? "#dc2626" : nghe ? NGHE_FG : "#d1d5db", background: w ? "#fee2e2" : nghe ? NGHE_BG : "#fff", color: nghe && !w ? NGHE_FG : undefined, fontWeight: nghe ? 600 : undefined }} title={w || (nghe ? "GV Nghề" : "")}>
                            <option value="">— trống —</option>
                            {data.teachers.map((t) => <option key={t.id} value={t.id}>{t.name}{t.gvNghe ? " (GV Nghề)" : ""}</option>)}
                          </select>
                        ) : (
                          <div key={i} style={{ fontSize: 12, color: w ? "#dc2626" : nghe ? NGHE_FG : "#111827", background: nghe ? NGHE_BG : undefined, fontWeight: nghe ? 600 : undefined, borderRadius: 4, padding: nghe ? "0 4px" : undefined }}>{teacherById[arr[i]]?.name || "—"}</div>
                        );
                      })}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
        {isAdmin && draftInv && <button type="button" style={btn} disabled={saving} onClick={() => run(() => updateThiKhaoSat(schoolId, examId, { invigilation: draftInv }), "Đã lưu phân công coi thi.")}>💾 Lưu phân công</button>}
        {isAdmin && draftInv && <button type="button" style={btnLight} onClick={() => setDraftInv(null)}>Huỷ</button>}
      </div>
      {[["Cơ hữu", coHuuList], ["Thỉnh giảng", tgList]].map(([lbl, list]) => (
        <details key={lbl} open style={{ marginTop: 12 }}>
          <summary style={{ cursor: "pointer", fontSize: 13, fontWeight: 600 }}>Báo cáo coi thi — GV {lbl} ({list.length} người · {list.reduce((a, t) => a + tietCoiThi(t.id), 0)} tiết; cả ngày = 8 tiết, sáng = 5, chiều = 3)</summary>
          <table style={{ ...tbl, width: "auto", marginTop: 6 }}>
            <thead><tr><th style={th}>STT</th><th style={th}>Giáo viên</th><th style={th}>Bộ môn</th><th style={th}>Số lượt</th><th style={th}>Buổi coi</th><th style={th}>Số tiết</th></tr></thead>
            <tbody>{list.map((t, i) => <tr key={t.id}><td style={td}>{i + 1}</td><td style={{ ...td, textAlign: "left" }}>{t.name}</td><td style={td}>{t.specialty}</td><td style={td}>{load[t.id] || 0}</td><td style={td}>{buoiLabel(t.id)}</td><td style={{ ...td, fontWeight: 700 }}>{tietCoiThi(t.id)}</td></tr>)}</tbody>
            <tfoot><tr><td style={{ ...tdB, textAlign: "left" }} colSpan={3}>Tổng</td><td style={tdB}>{list.reduce((a, t) => a + (load[t.id] || 0), 0)}</td><td style={tdB}></td><td style={tdB}>{list.reduce((a, t) => a + tietCoiThi(t.id), 0)}</td></tr></tfoot>
          </table>
        </details>
      ))}
    </div>
  );
}

// ---------- Ký tiết coi thi: danh sách GV coi thi + số tiết (sáng 5, chiều 3, cả ngày 8 / ngày) — in & xuất Excel ----------
const escH = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
function TabKyTiet({ data, exam, schedule, roomList, inv, teacherById, subjByKey, isAdmin }) {
  const items = sortItems(schedule);
  const rows = useMemo(() => {
    const by = {}; // tid -> { days: {date: Set(buoi)}, turns, details: [] }
    items.forEach(([iid, it]) => roomList.forEach(([rid, r]) => (((inv[iid] || {})[rid]) || []).forEach((tid) => {
      if (!tid) return;
      const x = (by[tid] = by[tid] || { days: {}, turns: 0, details: [] });
      (x.days[it.date] = x.days[it.date] || new Set()).add(it.buoi);
      x.turns++; x.details.push(`${subjByKey[it.subjectKey]?.label || it.subjectKey} – ${r.name}`);
    })));
    const tietOfDay = (set) => (set.has("S") && set.has("C") ? 8 : set.has("S") ? 5 : set.has("C") ? 3 : 0);
    return Object.entries(by).map(([tid, x]) => {
      const t = teacherById[tid] || { name: tid };
      const dayList = Object.entries(x.days).sort(([a], [b]) => a.localeCompare(b));
      return {
        tid, name: t.name, specialty: t.specialty || "", type: t.employmentType || "",
        tg: /thỉnh giảng/i.test(String(t.employmentType || "").normalize("NFC")),
        buoi: dayList.map(([d, set]) => `${fmtDate(d)}: ${set.has("S") && set.has("C") ? "Cả ngày" : set.has("S") ? "Sáng" : "Chiều"}`).join("; "),
        sang: dayList.filter(([, set]) => set.has("S") && !set.has("C")).length,
        chieu: dayList.filter(([, set]) => set.has("C") && !set.has("S")).length,
        caNgay: dayList.filter(([, set]) => set.has("S") && set.has("C")).length,
        turns: x.turns, tiet: dayList.reduce((a, [, set]) => a + tietOfDay(set), 0), details: x.details.join("; "),
      };
    }).sort((a, b) => cmpViName(a.name, b.name));
  }, [items, roomList, inv, teacherById, subjByKey]);
  const groups = [["GIÁO VIÊN CƠ HỮU", rows.filter((r) => !r.tg)], ["GIÁO VIÊN THỈNH GIẢNG", rows.filter((r) => r.tg)]].filter(([, l]) => l.length);
  const sum = (l, f) => l.reduce((a, r) => a + r[f], 0);
  const dates = [...new Set(items.map(([, it]) => it.date))].sort();
  const title = `BẢNG KÝ NHẬN TIẾT COI THI`;
  const sub = `${exam.name || "Thi khảo sát"}${dates.length ? ` — ngày ${dates.map(fmtDate).join(", ")}` : ""}`;
  const TIET_CA = { S: 5, C: 3 };
  // Tách theo CA (ngày + buổi): mỗi ca 1 danh sách GV coi, mỗi người TIET_CA[buổi] tiết.
  const caList = useMemo(() => {
    const m = {};
    items.forEach(([iid, it]) => roomList.forEach(([rid, r]) => (((inv[iid] || {})[rid]) || []).forEach((tid) => {
      if (!tid) return;
      const key = `${it.date}|${it.buoi}`;
      const ca = (m[key] = m[key] || { date: it.date, buoi: it.buoi, people: {} });
      const t = teacherById[tid] || { name: tid };
      const x = (ca.people[tid] = ca.people[tid] || { tid, name: t.name, specialty: t.specialty || "", type: t.employmentType || "", tg: /thỉnh giảng/i.test(String(t.employmentType || "").normalize("NFC")), details: [] });
      x.details.push(`${subjByKey[it.subjectKey]?.label || it.subjectKey} ${it.start} – ${r.name}${r.location ? ` (${r.location})` : ""}`);
    })));
    return Object.values(m).sort((a, b) => `${a.date}${a.buoi === "S" ? 0 : 1}`.localeCompare(`${b.date}${b.buoi === "S" ? 0 : 1}`)).map((ca) => ({
      ...ca, tiet: TIET_CA[ca.buoi] || 0,
      label: `CA ${ca.buoi === "S" ? "SÁNG" : "CHIỀU"} ${dowOf(ca.date)} ${fmtDate(ca.date)}`,
      list: Object.values(ca.people).sort((a, b) => (a.tg - b.tg) || cmpViName(a.name, b.name)),
    }));
  }, [items, roomList, inv, teacherById, subjByKey]); // eslint-disable-line

  const print = () => {
    const sections = caList.map((ca, ci) => `<section${ci ? ' class="pb"' : ""}>
<h1>${escH(title)}</h1><h2>${escH(sub)}</h2>
<h3>${escH(ca.label)} — ${ca.tiet} tiết/người</h3>
<table><thead><tr><th style="width:34px">STT</th><th>Họ và tên</th><th style="width:80px">Bộ môn</th><th>Phòng / môn coi</th><th style="width:48px">Số tiết</th><th style="width:110px">Ký nhận</th></tr></thead>
<tbody>${ca.list.map((r, i) => `<tr><td class="c">${i + 1}</td><td class="l">${escH(r.name)}</td><td class="c">${escH(r.specialty)}</td><td class="l sm">${escH(r.details.join("; "))}</td><td class="c b">${ca.tiet}</td><td></td></tr>`).join("")}
<tr class="tot"><td></td><td class="l">Cộng: ${ca.list.length} người</td><td></td><td></td><td class="c b">${ca.list.length * ca.tiet}</td><td></td></tr></tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div>Ngày ..... tháng ..... năm 20.....<br><b>HIỆU TRƯỞNG</b><br><i>(Ký, đóng dấu)</i></div></div>
</section>`).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Ký tiết coi thi</title><style>
@page{size:A4 portrait;margin:12mm 10mm 12mm 14mm}
body{font-family:"Times New Roman",Times,serif;font-size:13px;color:#000;margin:0}
h1{font-size:17px;text-align:center;margin:0 0 2px}h2{font-size:14px;text-align:center;font-weight:normal;margin:0 0 4px}h3{font-size:15px;text-align:center;margin:0 0 8px}
table{width:100%;border-collapse:collapse}th,td{border:1px solid #000;padding:5px;vertical-align:middle}
th{font-weight:bold;text-align:center}.c{text-align:center}.l{text-align:left}.b{font-weight:bold}.sm{font-size:12px}
tr{page-break-inside:avoid;height:30px}.tot td{font-weight:bold}.pb{page-break-before:always}
.sign{display:flex;justify-content:space-between;margin-top:18px;text-align:center}.sign div{width:45%}
</style></head><body>${sections}<script>window.onload=function(){window.print()}</script></body></html>`;
    openPrintWindow(html);
  };

  if (!rows.length) return <p style={hint}>Chưa có phân công coi thi — vào tab <b>GV coi thi</b> để phân công trước.</p>;
  return (
    <div>
      <p style={hint}>Bảng ký nhận tách theo <b>ca sáng (5 tiết/người)</b> và <b>ca chiều (3 tiết/người)</b>; GV coi cả ngày có tên ở cả 2 ca (cộng 8 tiết). Bản in: mỗi ca 1 trang, cột “Ký nhận” để trống cho GV ký.</p>
      <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
        <button type="button" style={btn} onClick={print}>🖨️ In bảng ký tiết (theo ca)</button>
        <span style={{ fontSize: 13, alignSelf: "center" }}>{rows.length} GV · {sum(rows, "turns")} lượt coi · <b>{sum(rows, "tiet")} tiết</b></span>
      </div>
      {caList.map((ca) => (
        <div key={ca.date + ca.buoi} style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 700, fontSize: 15, margin: "6px 0" }}>{ca.label} — {ca.tiet} tiết/người · {ca.list.length} người · {ca.list.length * ca.tiet} tiết</div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ ...tbl, width: "auto" }}>
              <thead><tr>{["STT", "Họ và tên", "Bộ môn", "Loại", "Phòng / môn coi", "Số tiết", "Ký nhận"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
              <tbody>
                {ca.list.map((r, i) => (
                  <tr key={r.tid}>
                    <td style={td}>{i + 1}</td>
                    <td style={{ ...tdB, textAlign: "left" }}>{r.name}</td>
                    <td style={td}>{r.specialty}</td>
                    <td style={td}>{r.type}</td>
                    <td style={{ ...td, textAlign: "left", fontSize: 12 }}>{r.details.join("; ")}</td>
                    <td style={{ ...tdB, color: "#0f766e" }}>{ca.tiet}</td>
                    <td style={{ ...td, minWidth: 100 }}></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
      <details style={{ marginTop: 8 }}>
        <summary style={{ cursor: "pointer", fontWeight: 600, fontSize: 13 }}>Tổng hợp theo giáo viên ({rows.length} người · {sum(rows, "tiet")} tiết)</summary>
        <table style={{ ...tbl, width: "auto", marginTop: 6 }}>
          <thead><tr>{["STT", "Họ và tên", "Loại", "Buổi coi thi", "Sáng (5)", "Chiều (3)", "Cả ngày (8)", "Số tiết"].map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>{rows.map((r, i) => <tr key={r.tid}><td style={td}>{i + 1}</td><td style={{ ...td, textAlign: "left" }}>{r.name}</td><td style={td}>{r.type}</td><td style={{ ...td, textAlign: "left" }}>{r.buoi}</td><td style={td}>{r.sang || ""}</td><td style={td}>{r.chieu || ""}</td><td style={td}>{r.caNgay || ""}</td><td style={tdB}>{r.tiet}</td></tr>)}</tbody>
        </table>
      </details>
    </div>
  );
}

// ---------- Nhập điểm ----------
// Danh sách NGƯỜI CHẤM THI (chấm tay) — chỉ những người này (và admin) nhập được điểm môn họ chấm.
function GradersPanel({ data, graders, gradeSubjOf, isAdmin, saving, run, schoolId, examId }) {
  const [pick, setPick] = useState("");
  const [sk, setSk] = useState("van");
  const subjects = data.subjects || [];
  const tById = Object.fromEntries((data.teachers || []).map((t) => [t.id, t]));
  const list = Object.keys(graders).filter((tid) => gradeSubjOf(tid).length).sort((a, b) => cmpViName(tById[a]?.name || a, tById[b]?.name || b));
  const save = (next) => run(() => updateThiKhaoSat(schoolId, examId, { graders: next }), "Đã cập nhật danh sách người chấm.");
  const add = () => { if (!pick) return; const cur = gradeSubjOf(pick); if (cur.includes(sk)) return; save({ ...graders, [pick]: [...cur, sk] }); setPick(""); };
  const remove = (tid, k) => { const rest = gradeSubjOf(tid).filter((x) => x !== k); const next = { ...graders }; if (rest.length) next[tid] = rest; else delete next[tid]; save(next); };
  return (
    <div style={{ ...card, marginBottom: 12, maxWidth: 820 }}>
      <div style={{ fontWeight: 700, marginBottom: 6 }}>🖊️ Người chấm thi được nhập điểm ({list.length})</div>
      {!list.length ? <div style={{ fontSize: 13, color: "#6b7280" }}>Chưa phân công người chấm — hiện chỉ admin nhập được điểm.</div> : (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {list.flatMap((tid) => gradeSubjOf(tid).map((k) => (
            <span key={tid + k} style={{ fontSize: 13, background: "#fff", border: "1px solid #99f6e4", borderRadius: 999, padding: "2px 10px" }}>
              {tById[tid]?.name || tid} · <b>{subjects.find((s) => s.key === k)?.label || k}</b>
              {isAdmin && <button type="button" title="Bỏ" disabled={saving} onClick={() => remove(tid, k)} style={{ marginLeft: 6, border: "none", background: "transparent", color: "#dc2626", cursor: "pointer", fontWeight: 700 }}>×</button>}
            </span>
          )))}
        </div>
      )}
      {isAdmin && (
        <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap", alignItems: "center" }}>
          <select value={pick} onChange={(e) => setPick(e.target.value)} style={sel}>
            <option value="">— Thêm người chấm —</option>
            {(data.teachers || []).slice().sort((a, b) => cmpViName(a.name, b.name)).map((t) => <option key={t.id} value={t.id}>{t.name}{t.specialty ? ` (${t.specialty})` : ""}</option>)}
          </select>
          <select value={sk} onChange={(e) => setSk(e.target.value)} style={sel}>
            {subjects.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
          </select>
          <button type="button" style={btn} disabled={saving || !pick} onClick={add}>+ Thêm</button>
        </div>
      )}
    </div>
  );
}

// Nhập điểm: chọn nhập THEO LỚP hoặc THEO PHÒNG THI.
function TabDiem(props) {
  const [mode, setMode] = useState("phong"); // "phong" | "lop" — tab theo phòng thi đứng trước và mở mặc định
  const pill = (on) => ({ padding: "6px 14px", borderRadius: 999, fontSize: 13, cursor: "pointer", fontWeight: 600, border: "1px solid #0f766e", background: on ? "#0f766e" : "#fff", color: on ? "#fff" : "#0f766e" });
  return (
    <div>
      <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
        <button type="button" style={pill(mode === "phong")} onClick={() => setMode("phong")}>🚪 Nhập theo phòng thi</button>
        <button type="button" style={pill(mode === "lop")} onClick={() => setMode("lop")}>🏫 Nhập theo lớp</button>
      </div>
      {mode === "phong" ? <TabDiemPhong {...props} /> : <TabDiemLop {...props} />}
    </div>
  );
}

// Nhập điểm THEO PHÒNG THI: chọn phòng -> hiện thí sinh của phòng (mọi lớp trong phòng) theo SBD, nhập điểm các môn của nhóm thi.
// Điểm lưu đúng như nhập theo lớp (tách theo lớp của từng thí sinh khi gửi lên).
function TabDiemPhong({ data, exam, isAdmin, saving, run, schoolId, examId, subjByKey, sbdOf, rooms }) {
  const roomList = Object.entries(rooms || {}).sort((a, b) => String(a[1].name || "").localeCompare(String(b[1].name || ""), "vi", { numeric: true }));
  const [roomId, setRoomId] = useState(roomList[0]?.[0] || "");
  const [draft, setDraft] = useState({}); // subjectKey -> { "classId|studentId": value }
  useEffect(() => setDraft({}), [roomId]);
  const studentByKey = useMemo(() => {
    const m = {};
    (data.classes12 || []).forEach((c) => (c.students || []).forEach((st) => { m[`${c.id}|${st.id}`] = { ...st, classId: c.id, className: c.name }; }));
    return m;
  }, [data]);
  const room = (rooms || {})[roomId];
  if (!room) return <p style={hint}>Chưa chia phòng thi nên chưa nhập điểm theo phòng được. Hãy chia phòng ở tab Phòng thi.</p>;
  const subs = (data.groups[room.group] || {}).subjects || [];
  const scores = exam.scores || {};
  const graders = exam.graders || {};
  const gradeSubjOf = (tid) => { const v = graders[tid]; return Array.isArray(v) ? v : v ? Object.values(v) : []; };
  const canEdit = (sk) => isAdmin || (!!data.me?.staffId && gradeSubjOf(data.me.staffId).includes(sk));
  const keys = room.students || [];
  const valOf = (sk, key) => {
    const d = (draft[sk] || {})[key];
    if (d !== undefined) return d;
    const v = (scores[sk] || {})[key];
    return v === undefined || v === null ? "" : String(v);
  };
  const setVal = (sk, key, v) => setDraft((d) => ({ ...d, [sk]: { ...(d[sk] || {}), [key]: v } }));
  const onPaste = (sk, idx, e) => {
    const text = e.clipboardData.getData("text");
    if (!/\n/.test(text.trim())) return;
    e.preventDefault();
    const vals = text.replace(/\r/g, "").split("\n").filter((x, i, a) => i < a.length - 1 || x !== "");
    setDraft((d) => {
      const m = { ...(d[sk] || {}) };
      vals.forEach((v, i) => { const k = keys[idx + i]; if (k) m[k] = v.split("\t")[0].trim(); });
      return { ...d, [sk]: m };
    });
  };
  const okNum = (v) => { const n = Number(String(v).replace(",", ".")); return n >= 0 && n <= 10; };
  const invalid = Object.values(draft).some((m) => Object.values(m).some((v) => v !== "" && !okNum(v)));
  const dirtyCount = Object.values(draft).reduce((a, m) => a + Object.keys(m).length, 0);
  const dirty = dirtyCount > 0;
  const save = () => run(async () => {
    for (const [sk, m] of Object.entries(draft)) {
      const byClass = {};
      Object.entries(m).forEach(([key, v]) => { const [cid, sid] = key.split("|"); (byClass[cid] = byClass[cid] || {})[sid] = v === "" ? null : v; });
      for (const [classId, sc] of Object.entries(byClass)) await saveScoresThiKhaoSat(schoolId, examId, { subjectKey: sk, classId, scores: sc });
    }
    setDraft({});
  }, `Đã lưu điểm phòng ${room.name}.`);
  const saveBtn = (
    <button type="button" style={{ ...btn, opacity: dirty ? 1 : 0.5 }} disabled={saving || invalid || !dirty} onClick={save}>💾 Lưu điểm{dirty ? ` (${dirtyCount})` : ""}</button>
  );
  return (
    <div>
      <p style={hint}>Chọn phòng thi, nhập điểm theo từng thí sinh (0–10, dấu chấm hoặc phẩy). Có thể copy cả cột điểm từ Excel dán vào ô đầu tiên. {isAdmin ? "" : "Chỉ người chấm thi được phân công mới nhập được điểm môn mình chấm."}</p>
      <GradersPanel {...{ data, graders, gradeSubjOf, isAdmin, saving, run, schoolId, examId }} />
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <select value={roomId} onChange={(e) => setRoomId(e.target.value)} style={sel}>
          {roomList.map(([rid, r]) => <option key={rid} value={rid}>{r.name}{r.location ? ` — ${r.location}` : ""} · Nhóm {r.group} ({(r.students || []).length} TS)</option>)}
        </select>
        {saveBtn}
        {dirty && <button type="button" style={btnLight} onClick={() => setDraft({})}>Huỷ</button>}
        {invalid && <span style={{ color: "#dc2626", fontSize: 13 }}>Có điểm không hợp lệ (phải 0–10)</span>}
        {!subs.some((k) => canEdit(k)) && <span style={{ fontSize: 13, color: "#b45309" }}>Bạn không được phân công chấm môn nào của phòng này nên chỉ xem được điểm.</span>}
      </div>
      <div style={{ overflowX: "auto" }}>
      <table style={tbl}>
        <thead><tr><th style={th}>STT</th><th style={th}>SBD</th><th style={th}>Họ và tên</th><th style={th}>Ngày sinh</th><th style={th}>Lớp</th>{subs.map((k) => <th key={k} style={th}>{subjByKey[k]?.label}{!canEdit(k) && <div style={{ fontSize: 10, fontWeight: 400 }}>(chỉ xem)</div>}</th>)}<th style={{ ...th, ...stickyTong, background: "#f3f4f6" }}>Tổng</th><th style={{ ...th, ...stickyTB, background: "#f3f4f6" }}>Trung bình</th></tr></thead>
        <tbody>
          {keys.map((key, i) => {
            const st = studentByKey[key] || {};
            const stat = scoreStats(subs.map((k) => valOf(k, key)));
            const partial = !!stat && stat.n < subs.length;
            return (
              <tr key={key}>
                <td style={td}>{i + 1}</td>
                <td style={td}>{sbdOf[key]?.sbd || ""}</td>
                <td style={{ ...td, textAlign: "left", whiteSpace: "nowrap" }}>{st.name}</td>
                <td style={td}>{fmtDob(st.dob)}</td>
                <td style={td}>{st.className}</td>
                {subs.map((k) => {
                  const v = valOf(k, key);
                  const bad = v !== "" && !okNum(v);
                  return <td key={k} style={td}>{canEdit(k) ? <input value={v} onChange={(e) => setVal(k, key, e.target.value)} onPaste={(e) => onPaste(k, i, e)} style={{ ...sel, width: 56, textAlign: "center", borderColor: bad ? "#dc2626" : "#d1d5db", background: (draft[k] || {})[key] !== undefined ? "#fef9c3" : "#fff" }} inputMode="decimal" /> : v}</td>;
                })}
                <td style={{ ...tdB, ...stickyTong, color: partial ? "#6b7280" : undefined }} title={partial ? `Mới có ${stat.n}/${subs.length} môn` : undefined}>{stat ? fmtVn(stat.sum) : ""}</td>
                <td style={{ ...tdB, ...stickyTB, color: partial ? "#6b7280" : undefined }} title={partial ? `Mới có ${stat.n}/${subs.length} môn` : undefined}>{stat ? fmtVn(stat.avg) : ""}</td>
              </tr>
            );
          })}
          <tr style={{ background: "#f0fdfa" }}>
            <td style={tdB} colSpan={5}>Trung bình phòng (số thí sinh có điểm)</td>
            {subs.map((k) => { const a = keys.map((key) => scoreStats([valOf(k, key)])).filter(Boolean).map((x) => x.sum); return <td key={k} style={tdB}>{a.length ? `${fmtVn(round2(a.reduce((x, y) => x + y, 0) / a.length))} (${a.length})` : ""}</td>; })}
            {(() => { const all = keys.map((key) => scoreStats(subs.map((k) => valOf(k, key)))).filter(Boolean); const m = (f) => (all.length ? fmtVn(round2(all.reduce((x, y) => x + f(y), 0) / all.length)) : ""); return (<><td style={{ ...tdB, ...stickyTong, background: "#f0fdfa" }}>{m((y) => y.sum)}</td><td style={{ ...tdB, ...stickyTB, background: "#f0fdfa" }}>{m((y) => y.avg)}</td></>); })()}
          </tr>
        </tbody>
      </table>
      </div>
      {dirty && (
        <div style={{ position: "sticky", bottom: 0, zIndex: 20, display: "flex", gap: 10, alignItems: "center", padding: "10px 12px", marginTop: 10, background: "#fffbeb", border: "1px solid #fcd34d", borderRadius: 8, boxShadow: "0 -4px 12px rgba(0,0,0,0.08)" }}>
          <span style={{ fontSize: 14 }}>Có <b>{dirtyCount}</b> ô điểm chưa lưu.</span>
          <button type="button" style={btn} disabled={saving || invalid} onClick={save}>💾 Lưu điểm</button>
          <button type="button" style={btnLight} onClick={() => setDraft({})}>Huỷ</button>
        </div>
      )}
    </div>
  );
}

function TabDiemLop({ data, exam, groupOf, isAdmin, saving, run, schoolId, examId, subjByKey, sbdOf, rooms }) {
  const classes = data.classes12.filter((c) => groupOf(c));
  const [classId, setClassId] = useState(classes[0]?.id || "");
  const [draft, setDraft] = useState({}); // subjectKey -> {studentId: value}
  const [sheetOf, setSheetOf] = useState(null); // { subjectKey, student } — bấm đúp ô điểm -> hồ sơ chấm phiếu
  useEffect(() => setDraft({}), [classId]);
  const cls = classes.find((c) => c.id === classId);
  if (!cls) return <p style={hint}>Chưa có lớp nào thuộc nhóm thi.</p>;
  const subs = data.groups[groupOf(cls)].subjects;
  const scores = exam.scores || {};
  // Ghi chú chấm phiếu (đẩy kèm điểm từ "Chấm cả phòng" OMR): { subjectKey: { "classId|studentId": text } }
  const notesOf = (sid) => subs.map((k) => { const t = ((exam.scoreNotes || {})[k] || {})[`${cls.id}|${sid}`]; return t ? `${subjByKey[k]?.label || k}: ${t}` : null; }).filter(Boolean).join(" | ");
  const graders = exam.graders || {}; // { staffId: [subjectKey...] } — người chấm (chấm tay) được nhập điểm
  const gradeSubjOf = (tid) => { const v = graders[tid]; return Array.isArray(v) ? v : v ? Object.values(v) : []; };
  const canEdit = (sk) => isAdmin || (!!data.me?.staffId && gradeSubjOf(data.me.staffId).includes(sk));
  const valOf = (sk, sid) => {
    const d = (draft[sk] || {})[sid];
    if (d !== undefined) return d;
    const v = (scores[sk] || {})[`${cls.id}|${sid}`];
    return v === undefined || v === null ? "" : String(v);
  };
  const setVal = (sk, sid, v) => setDraft((d) => ({ ...d, [sk]: { ...(d[sk] || {}), [sid]: v } }));
  // Dán cả cột từ Excel vào 1 ô -> điền xuống các HS phía dưới
  const onPaste = (sk, idx, e) => {
    const text = e.clipboardData.getData("text");
    if (!/\n/.test(text.trim())) return;
    e.preventDefault();
    const vals = text.replace(/\r/g, "").split("\n").filter((x, i, a) => i < a.length - 1 || x !== "");
    setDraft((d) => {
      const m = { ...(d[sk] || {}) };
      vals.forEach((v, i) => { const st = cls.students[idx + i]; if (st) m[st.id] = v.split("\t")[0].trim(); });
      return { ...d, [sk]: m };
    });
  };
  const invalid = Object.values(draft).some((m) => Object.values(m).some((v) => v !== "" && !(Number(String(v).replace(",", ".")) >= 0 && Number(String(v).replace(",", ".")) <= 10)));
  const save = () => run(async () => {
    for (const [sk, m] of Object.entries(draft)) {
      if (!Object.keys(m).length) continue;
      await saveScoresThiKhaoSat(schoolId, examId, { subjectKey: sk, classId: cls.id, scores: Object.fromEntries(Object.entries(m).map(([k, v]) => [k, v === "" ? null : v])) });
    }
    setDraft({});
  }, `Đã lưu điểm lớp ${cls.name}.`);
  const roomNameOf = (sid) => { const r = sbdOf[`${cls.id}|${sid}`]; return r ? rooms[r.roomId]?.name : ""; };
  const dirty = Object.values(draft).some((m) => Object.keys(m).length);
  const dirtyCount = Object.values(draft).reduce((a, m) => a + Object.keys(m).length, 0);
  const editableSubs = subs.filter((k) => canEdit(k));
  return (
    <div>
      <p style={hint}>Chọn lớp, nhập điểm (0–10, dùng dấu chấm hoặc phẩy). Có thể copy cả cột điểm từ Excel rồi dán vào ô đầu tiên. <b>Bấm đúp vào ô điểm</b> để xem đề thi, bài làm, đáp án của thí sinh. {isAdmin ? "" : "Chỉ người chấm thi được phân công mới nhập được điểm môn mình chấm."}</p>
      <GradersPanel {...{ data, graders, gradeSubjOf, isAdmin, saving, run, schoolId, examId }} />
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <select value={classId} onChange={(e) => setClassId(e.target.value)} style={sel}>
          {classes.map((c) => <option key={c.id} value={c.id}>{c.name} — Nhóm {groupOf(c)}</option>)}
        </select>
        <button type="button" style={{ ...btn, opacity: dirty ? 1 : 0.5 }} disabled={saving || invalid || !dirty} onClick={save} title={dirty ? "Lưu các điểm đã sửa" : "Chưa có điểm nào được sửa"}>💾 Lưu điểm{dirty ? ` (${dirtyCount})` : ""}</button>
        {dirty && <button type="button" style={btnLight} onClick={() => setDraft({})}>Huỷ</button>}
        {!editableSubs.length && <span style={{ fontSize: 13, color: "#b45309" }}>Bạn không được phân công chấm môn nào của lớp này nên chỉ xem được điểm.</span>}
        {invalid && <span style={{ color: "#dc2626", fontSize: 13 }}>Có điểm không hợp lệ (phải 0–10)</span>}
      </div>
      <table style={tbl}>
        <thead><tr><th style={th}>STT</th><th style={th}>SBD</th><th style={th}>Phòng</th><th style={th}>Họ và tên</th><th style={th}>Ngày sinh</th>{subs.map((k) => <th key={k} style={th}>{subjByKey[k]?.label}{!canEdit(k) && <div style={{ fontSize: 10, fontWeight: 400 }}>(chỉ xem)</div>}</th>)}<th style={th}>Tổng</th><th style={th}>Trung bình</th><th style={th}>Ghi chú</th></tr></thead>
        <tbody>
          {cls.students.map((s, i) => {
            const stat = scoreStats(subs.map((k) => valOf(k, s.id)));
            const partial = !!stat && stat.n < subs.length;
            return (
              <tr key={s.id}>
                <td style={td}>{i + 1}</td>
                <td style={td}>{sbdOf[`${cls.id}|${s.id}`]?.sbd || ""}</td>
                <td style={td}>{roomNameOf(s.id)}</td>
                <td style={{ ...td, textAlign: "left", whiteSpace: "nowrap" }}>{s.name}</td>
                <td style={td}>{fmtDob(s.dob)}</td>
                {subs.map((k) => {
                  const v = valOf(k, s.id); const n = Number(String(v).replace(",", "."));
                  const bad = v !== "" && !(n >= 0 && n <= 10);
                  return <td key={k} style={{ ...td, cursor: "pointer" }} title="Bấm đúp để xem đề, bài làm, đáp án" onDoubleClick={() => setSheetOf({ subjectKey: k, student: s })}>{canEdit(k) ? <input value={v} onChange={(e) => setVal(k, s.id, e.target.value)} onPaste={(e) => onPaste(k, i, e)} style={{ ...sel, width: 56, textAlign: "center", borderColor: bad ? "#dc2626" : "#d1d5db", background: (draft[k] || {})[s.id] !== undefined ? "#fef9c3" : "#fff" }} inputMode="decimal" /> : v}</td>;
                })}
                <td style={{ ...tdB, color: partial ? "#6b7280" : undefined }} title={partial ? `Mới có ${stat.n}/${subs.length} môn` : undefined}>{stat ? fmtVn(stat.sum) : ""}</td>
                <td style={{ ...tdB, color: partial ? "#6b7280" : undefined }} title={partial ? `Mới có ${stat.n}/${subs.length} môn` : undefined}>{stat ? fmtVn(stat.avg) : ""}</td>
                <td style={{ ...td, textAlign: "left", fontSize: 12, color: "#b45309", maxWidth: 360 }}>{notesOf(s.id)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {dirty && (
        // Thanh Lưu dính đáy màn hình: bảng dài thì nút ở đầu trang bị cuộn khuất -> luôn thấy nút Lưu khi có điểm chưa lưu.
        <div style={{ position: "sticky", bottom: 0, zIndex: 20, display: "flex", gap: 10, alignItems: "center", padding: "10px 12px", marginTop: 10, background: "#fffbeb", border: "1px solid #fcd34d", borderRadius: 8, boxShadow: "0 -4px 12px rgba(0,0,0,0.08)" }}>
          <span style={{ fontSize: 14 }}>Có <b>{dirtyCount}</b> ô điểm chưa lưu.</span>
          <button type="button" style={btn} disabled={saving || invalid} onClick={save}>💾 Lưu điểm</button>
          <button type="button" style={btnLight} onClick={() => setDraft({})}>Huỷ</button>
          {invalid && <span style={{ color: "#dc2626", fontSize: 13 }}>Có điểm không hợp lệ (phải 0–10)</span>}
        </div>
      )}
      {sheetOf && (
        <ThiKhaoSatSheetModal schoolId={schoolId} examId={examId} subjectKey={sheetOf.subjectKey} subjectLabel={subjByKey[sheetOf.subjectKey]?.label || sheetOf.subjectKey}
          classId={cls.id} student={sheetOf.student} canEdit={canEdit(sheetOf.subjectKey)} onClose={() => setSheetOf(null)} />
      )}
    </div>
  );
}

// ---------- Xem điểm theo danh sách lớp (chỉ xem) ----------
function TabXemDiem({ data, exam, groupOf, schoolId, examId, subjByKey, sbdOf, rooms, isAdmin, scoreAccess }) {
  // scoreAccess = null: xem mọi lớp/môn (owner/admin); ngược lại { classId: [môn được xem] } — GVCN: mọi môn lớp mình, GV bộ môn: môn mình dạy (PCCM).
  const classes = data.classes12.filter((c) => groupOf(c) && (!scoreAccess || (scoreAccess[c.id] || []).length));
  const [classId, setClassId] = useState(classes[0]?.id || "");
  const [q, setQ] = useState("");
  const [onlyMissing, setOnlyMissing] = useState(false);
  const [sheetOf, setSheetOf] = useState(null); // { subjectKey, student } — bấm đúp ô điểm -> hồ sơ chấm phiếu
  const cls = classes.find((c) => c.id === classId);
  if (!cls) return <p style={hint}>{scoreAccess ? "Bạn chưa được phân công chủ nhiệm hoặc dạy lớp 12 nào có môn thi khảo sát." : "Chưa có lớp nào thuộc nhóm thi."}</p>;
  const groupSubs = data.groups[groupOf(cls)].subjects;
  const subs = scoreAccess ? groupSubs.filter((k) => (scoreAccess[cls.id] || []).includes(k)) : groupSubs;
  const fullView = subs.length === groupSubs.length; // chỉ thấy 1 phần các môn thì không tính Tổng
  const scores = exam.scores || {};
  const scoreOf = (k, sid) => { const v = (scores[k] || {})[`${cls.id}|${sid}`]; return v === undefined || v === null || v === "" ? null : Number(v); };
  const notesOf = (sid) => subs.map((k) => { const t = ((exam.scoreNotes || {})[k] || {})[`${cls.id}|${sid}`]; return t ? `${subjByKey[k]?.label || k}: ${t}` : null; }).filter(Boolean).join(" | ");
  const roomNameOf = (sid) => { const r = sbdOf[`${cls.id}|${sid}`]; return r ? rooms[r.roomId]?.name : ""; };
  const rows = cls.students.map((s, i) => {
    const v = subs.map((k) => scoreOf(k, s.id));
    const full = v.every((x) => x !== null);
    // Tổng / Trung bình tính trên các môn ĐÃ CÓ điểm (không chờ đủ hết); chỉ khi xem đủ mọi môn của nhóm thi.
    const have = v.filter((x) => x !== null);
    const total = fullView && have.length ? round2(have.reduce((a, b) => a + b, 0)) : null;
    return { s, i, v, full, n: have.length, total, tb: total !== null ? round2(total / have.length) : null };
  });
  const kw = q.trim().toLowerCase();
  const shown = rows.filter((r) => (!kw || r.s.name.toLowerCase().includes(kw) || String(sbdOf[`${cls.id}|${r.s.id}`]?.sbd || "").includes(kw)) && (!onlyMissing || !r.full));
  const avg = (arr) => (arr.length ? round2(arr.reduce((a, b) => a + b, 0) / arr.length) : "");
  const fmt = (x) => (x === null ? "" : String(round2(x)).replace(".", ","));
  return (
    <div>
      <p style={hint}>Điểm các môn thi của từng lớp theo danh sách lớp (chỉ xem). Ô trống = chưa có điểm hoặc vắng thi. <b>Bấm đúp vào ô điểm</b> để xem đề, bài làm, đáp án.</p>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <select value={classId} onChange={(e) => setClassId(e.target.value)} style={sel}>
          {classes.map((c) => <option key={c.id} value={c.id}>{c.name} — Nhóm {groupOf(c)}</option>)}
        </select>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tìm tên / SBD…" style={sel} />
        <label style={{ fontSize: 13 }}><input type="checkbox" checked={onlyMissing} onChange={(e) => setOnlyMissing(e.target.checked)} /> Chỉ HS chưa đủ điểm</label>
        <span style={{ fontSize: 13, color: "#6b7280" }}>Sĩ số {rows.length} · đủ điểm {rows.filter((r) => r.full).length}</span>
      </div>
      <table style={tbl}>
        <thead><tr><th style={th}>STT</th><th style={th}>SBD</th><th style={th}>Phòng</th><th style={th}>Họ và tên</th><th style={th}>Ngày sinh</th>{subs.map((k) => <th key={k} style={th}>{subjByKey[k]?.label}</th>)}<th style={th}>Tổng</th><th style={th}>Trung bình</th><th style={th}>Ghi chú chấm phiếu</th></tr></thead>
        <tbody>
          {shown.map((r) => (
            <tr key={r.s.id}>
              <td style={td}>{r.i + 1}</td>
              <td style={td}>{sbdOf[`${cls.id}|${r.s.id}`]?.sbd || ""}</td>
              <td style={td}>{roomNameOf(r.s.id)}</td>
              <td style={{ ...td, textAlign: "left", whiteSpace: "nowrap" }}>{r.s.name}</td>
              <td style={td}>{fmtDob(r.s.dob)}</td>
              {subs.map((k, j) => <td key={k} style={{ ...td, cursor: "pointer", color: r.v[j] !== null && r.v[j] < 5 ? "#dc2626" : undefined }} title="Bấm đúp để xem đề, bài làm, đáp án" onDoubleClick={() => setSheetOf({ subjectKey: k, student: r.s })}>{fmt(r.v[j])}</td>)}
              <td style={{ ...tdB, color: r.total !== null && !r.full ? "#6b7280" : undefined }} title={r.total !== null && !r.full ? `Mới có ${r.n}/${subs.length} môn` : undefined}>{fmt(r.total)}</td>
              <td style={{ ...tdB, color: r.tb !== null && !r.full ? "#6b7280" : undefined }} title={r.tb !== null && !r.full ? `Mới có ${r.n}/${subs.length} môn` : undefined}>{fmt(r.tb)}</td>
              <td style={{ ...td, textAlign: "left", fontSize: 12, color: "#b45309", maxWidth: 360 }}>{notesOf(r.s.id)}</td>
            </tr>
          ))}
          <tr>
            <td style={tdB} colSpan={5}>Điểm trung bình lớp (số HS có điểm)</td>
            {subs.map((k, j) => { const a = rows.map((r) => r.v[j]).filter((x) => x !== null); return <td key={k} style={tdB}>{avg(a) === "" ? "" : `${String(avg(a)).replace(".", ",")} (${a.length})`}</td>; })}
            <td style={tdB}>{(() => { const a = rows.filter((r) => r.total !== null).map((r) => r.total); return avg(a) === "" ? "" : String(avg(a)).replace(".", ","); })()}</td>
            <td style={tdB}>{(() => { const a = rows.filter((r) => r.tb !== null).map((r) => r.tb); return avg(a) === "" ? "" : String(avg(a)).replace(".", ","); })()}</td>
            <td style={td} />
          </tr>
        </tbody>
      </table>
      {sheetOf && (
        <ThiKhaoSatSheetModal schoolId={schoolId} examId={examId} subjectKey={sheetOf.subjectKey} subjectLabel={subjByKey[sheetOf.subjectKey]?.label || sheetOf.subjectKey}
          classId={cls.id} student={sheetOf.student} canEdit={false} onClose={() => setSheetOf(null)} />
      )}
    </div>
  );
}

// ---------- Thống kê ----------
function statOf(arr) {
  const n = arr.length;
  if (!n) return { n: 0 };
  const sum = arr.reduce((a, b) => a + b, 0);
  return {
    n, tb: round2(sum / n), max: Math.max(...arr), min: Math.min(...arr),
    gioi: arr.filter((x) => x >= 8).length, kha: arr.filter((x) => x >= 6.5 && x < 8).length,
    tbinh: arr.filter((x) => x >= 5 && x < 6.5).length, duoi5: arr.filter((x) => x < 5).length, le3: arr.filter((x) => x <= 3).length, liet: arr.filter((x) => x <= 1).length,
  };
}
function TabThongKe({ data, exam, groupOf, subjByKey, isAdmin }) {
  const [sk, setSk] = useState("van");
  const scores = exam.scores || {};
  const classes = data.classes12.filter((c) => groupOf(c));
  const subjInGroup = (g) => data.groups[g].subjects;
  // giá trị của 1 HS theo lựa chọn (môn hoặc tổng 4 môn của nhóm)
  const valOf = (c, sid) => {
    if (sk !== "tong") { const v = (scores[sk] || {})[`${c.id}|${sid}`]; return typeof v === "number" ? v : null; }
    const vs = subjInGroup(groupOf(c)).map((k) => (scores[k] || {})[`${c.id}|${sid}`]);
    return vs.every((x) => typeof x === "number") ? round2(vs.reduce((a, b) => a + b, 0)) : null;
  };
  const applies = (c) => sk === "tong" || subjInGroup(groupOf(c)).includes(sk);
  const isTong = sk === "tong";
  const pct = (a, n) => (n ? `${a} (${Math.round((a / n) * 1000) / 10}%)` : "");
  const rowsFor = (list) => list.filter(applies).map((c) => {
    const arr = c.students.map((s) => valOf(c, s.id)).filter((x) => x !== null);
    return { c, siso: c.students.length, ...statOf(arr), arr };
  });
  const rows = rowsFor(classes);
  const groupRows = [1, 2, 3].map((g) => {
    const rs = rows.filter((r) => groupOf(r.c) === g);
    const arr = rs.flatMap((r) => r.arr);
    return { g, siso: rs.reduce((s, r) => s + r.siso, 0), ...statOf(arr) };
  }).filter((r) => r.siso);
  const allArr = rows.flatMap((r) => r.arr);
  const all = { siso: rows.reduce((s, r) => s + r.siso, 0), ...statOf(allArr) };
  const head = isTong ? ["Sĩ số", "Có điểm", "TB tổng", "Cao nhất", "Thấp nhất"] : ["Sĩ số", "Có điểm", "Điểm TB", "≥ 8", "6,5 – <8", "5 – <6,5", "< 5", "≤ 3", "≤ 1 (liệt)", "Cao nhất", "Thấp nhất"];
  const cells = (r) => (isTong ? [r.siso, r.n || 0, r.tb ?? "", r.max ?? "", r.min ?? ""] : [r.siso, r.n || 0, r.tb ?? "", pct(r.gioi || 0, r.n), pct(r.kha || 0, r.n), pct(r.tbinh || 0, r.n), pct(r.duoi5 || 0, r.n), pct(r.le3 || 0, r.n), pct(r.liet || 0, r.n), r.max ?? "", r.min ?? ""]);
  const label = isTong ? "Tổng điểm 4 môn" : subjByKey[sk]?.label;
  // Bảng TB theo môn của từng nhóm
  const bySubjGroup = [1, 2, 3].map((g) => ({ g, cols: data.subjects.map((s) => {
    if (!subjInGroup(g).includes(s.key)) return null;
    const arr = classes.filter((c) => groupOf(c) === g).flatMap((c) => c.students.map((st) => (scores[s.key] || {})[`${c.id}|${st.id}`]).filter((x) => typeof x === "number"));
    return statOf(arr);
  }) }));
  // Xuất Excel (chỉ admin): mỗi môn + "Tổng điểm 4 môn" 1 sheet (đủ bảng theo lớp, theo Nhóm, Toàn khối), thêm sheet TB theo môn/nhóm.
  const exportExcel = () => {
    const wb = XLSX.utils.book_new();
    const sheetName = (t) => String(t).replace(/[\\/?*[\]:]/g, " ").slice(0, 31);
    const keys = [...data.subjects.map((x) => x.key), "tong"];
    keys.forEach((key) => {
      const tong = key === "tong";
      const subjOf = (g) => data.groups[g].subjects;
      const val = (c, sid) => {
        if (!tong) { const v = (scores[key] || {})[`${c.id}|${sid}`]; return typeof v === "number" ? v : null; }
        const vs = subjOf(groupOf(c)).map((k) => (scores[k] || {})[`${c.id}|${sid}`]);
        return vs.every((x) => typeof x === "number") ? round2(vs.reduce((a, b) => a + b, 0)) : null;
      };
      const rs = classes.filter((c) => tong || subjOf(groupOf(c)).includes(key)).map((c) => {
        const arr = c.students.map((st) => val(c, st.id)).filter((x) => x !== null);
        return { c, siso: c.students.length, ...statOf(arr), arr };
      });
      if (!rs.length) return;
      const hd = tong ? ["Sĩ số", "Có điểm", "TB tổng", "Cao nhất", "Thấp nhất"] : ["Sĩ số", "Có điểm", "Điểm TB", "≥ 8", "6,5 – <8", "5 – <6,5", "< 5", "≤ 3", "≤ 1 (liệt)", "Cao nhất", "Thấp nhất"];
      const cl = (r) => (tong ? [r.siso, r.n || 0, r.tb ?? "", r.max ?? "", r.min ?? ""] : [r.siso, r.n || 0, r.tb ?? "", pct(r.gioi || 0, r.n), pct(r.kha || 0, r.n), pct(r.tbinh || 0, r.n), pct(r.duoi5 || 0, r.n), pct(r.le3 || 0, r.n), pct(r.liet || 0, r.n), r.max ?? "", r.min ?? ""]);
      const aoa = [[`${tong ? "Tổng điểm 4 môn" : subjByKey[key]?.label} — ${exam.name || "Thi khảo sát"}`], [], ["Lớp", "Nhóm", ...hd]];
      rs.forEach((r) => aoa.push([r.c.name, `N${groupOf(r.c)}`, ...cl(r)]));
      [1, 2, 3].forEach((g) => {
        const gr = rs.filter((r) => groupOf(r.c) === g);
        if (!gr.length) return;
        aoa.push([`Cả Nhóm ${g}`, "", ...cl({ siso: gr.reduce((a, r) => a + r.siso, 0), ...statOf(gr.flatMap((r) => r.arr)) })]);
      });
      aoa.push(["Toàn khối", "", ...cl({ siso: rs.reduce((a, r) => a + r.siso, 0), ...statOf(rs.flatMap((r) => r.arr)) })]);
      XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(aoa), sheetName(tong ? "Tổng 4 môn" : subjByKey[key]?.label || key));
    });
    const tb = [["Nhóm", ...data.subjects.map((x) => x.label)]];
    bySubjGroup.forEach(({ g, cols }) => tb.push([`Nhóm ${g}`, ...cols.map((x) => (x && x.n ? `${x.tb} (${x.n} HS)` : x ? "—" : ""))]));
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(tb), "TB theo môn và nhóm");
    downloadWorkbook(wb, `thong_ke_thi_khao_sat_${String(exam.name || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/gi, "d").replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "ket_qua"}.xlsx`);
  };
  return (
    <div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 10 }}>
        <span style={{ fontSize: 13 }}>Thống kê theo:</span>
        <select value={sk} onChange={(e) => setSk(e.target.value)} style={sel}>
          {data.subjects.map((s) => <option key={s.key} value={s.key}>{s.label}</option>)}
          <option value="tong">Tổng điểm 4 môn</option>
        </select>
        {isAdmin && <button type="button" onClick={exportExcel} style={btn} title="Xuất toàn bộ thống kê (mọi môn + tổng 4 môn) ra file Excel — chỉ quản trị">⬇ Xuất Excel</button>}
      </div>
      <h4 style={{ margin: "6px 0" }}>{label} — theo lớp</h4>
      <div style={{ overflowX: "auto" }}>
        <table style={tbl}>
          <thead><tr><th style={th}>Lớp</th><th style={th}>Nhóm</th>{head.map((h) => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>
            {!rows.length && <tr><td style={td} colSpan={head.length + 2}>Môn này không có trong nhóm nào.</td></tr>}
            {rows.map((r) => <tr key={r.c.id}><td style={tdB}>{r.c.name}</td><td style={td}>N{groupOf(r.c)}</td>{cells(r).map((x, i) => <td key={i} style={td}>{x}</td>)}</tr>)}
            {groupRows.map((r) => <tr key={`g${r.g}`} style={{ background: "#f0fdfa" }}><td style={tdB}>Cả Nhóm {r.g}</td><td style={td}></td>{cells(r).map((x, i) => <td key={i} style={tdB}>{x}</td>)}</tr>)}
            {rows.length > 0 && <tr style={{ background: "#ecfeff" }}><td style={tdB}>Toàn khối</td><td style={td}></td>{cells(all).map((x, i) => <td key={i} style={tdB}>{x}</td>)}</tr>}
          </tbody>
        </table>
      </div>
      <h4 style={{ margin: "16px 0 6px" }}>Điểm trung bình theo môn và nhóm</h4>
      <table style={{ ...tbl, width: "auto" }}>
        <thead><tr><th style={th}>Nhóm</th>{data.subjects.map((s) => <th key={s.key} style={th}>{s.label}</th>)}</tr></thead>
        <tbody>{bySubjGroup.map(({ g, cols }) => <tr key={g}><td style={tdB}>Nhóm {g}</td>{cols.map((x, i) => <td key={i} style={{ ...td, background: x ? "#fff" : "#f3f4f6" }}>{x && x.n ? `${x.tb} (${x.n} HS)` : x ? "—" : ""}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}

const sel = { padding: "6px 8px", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13 };
const btn = { padding: "6px 12px", border: "1px solid #0f766e", borderRadius: 6, fontSize: 13, background: "#0f766e", color: "#fff", fontWeight: 600, cursor: "pointer" };
const btnLight = { ...btn, background: "#fff", color: "#0f766e" };
const btnLightSm = { ...btnLight, padding: "2px 8px", fontSize: 12 };
const btnDanger = { ...btn, background: "#fff", color: "#dc2626", borderColor: "#dc2626" };
const btnDangerSm = { ...btnDanger, padding: "2px 8px", fontSize: 12 };
const tabOff = { padding: "6px 14px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 999, cursor: "pointer", fontWeight: 600, fontSize: 13 };
const tabOn = { ...tabOff, background: "#0f766e", color: "#fff", borderColor: "#0f766e" };
const tbl = { borderCollapse: "collapse", fontSize: 13, width: "100%", background: "#fff" };
const th = { border: "1px solid #e5e7eb", padding: "6px 8px", background: "#f3f4f6", textAlign: "center", whiteSpace: "nowrap" };
const td = { border: "1px solid #e5e7eb", padding: "4px 6px", textAlign: "center", verticalAlign: "middle" };
const tdB = { ...td, fontWeight: 600 };
// Cột Tổng / Trung bình ghim sát mép phải bảng nhập điểm theo phòng: bảng rộng cuộn ngang vẫn luôn thấy.
const stickyTong = { position: "sticky", right: 86, background: "#fff", minWidth: 62, boxShadow: "-4px 0 6px -4px rgba(0,0,0,0.15)" };
const stickyTB = { position: "sticky", right: 0, background: "#fff", minWidth: 86 };
const hint = { color: "#6b7280", fontSize: 13, marginTop: 0 };
const card = { border: "1px solid #99f6e4", background: "#f0fdfa", borderRadius: 10, padding: "10px 14px", minWidth: 220 };
const errStyle = { color: "#dc2626", fontSize: 13 };
const okStyle = { color: "#0f766e", fontSize: 13 };

// ĐANG KHOÁ: chỉ chủ trường, admin và giáo viên xem được (ghi chỉ chủ trường); API cũng từ chối vai trò khác.
const HappySchoolThiKhaoSatGate = () => {
  const schoolId = getActiveSchoolId();
  const [roles, setRoles] = useState(undefined); // undefined = đang tải; xét MỌI vai trò (tài khoản có thể vừa teacher vừa schedule_viewer)
  useEffect(() => {
    if (!schoolId) { setRoles([]); return; }
    listMySchools().then((l) => {
      const m = (l || []).find((x) => x.id === schoolId) || {};
      setRoles(Array.isArray(m.roles) && m.roles.length ? m.roles : m.role ? [m.role] : []);
    }).catch(() => setRoles([]));
  }, [schoolId]);
  if (roles === undefined) return <div style={{ padding: 24 }}>Đang tải…</div>;
  if (!roles.some((r) => ["owner", "admin", "teacher"].includes(r))) {
    return (
      <div style={{ padding: 24, maxWidth: 560, margin: "40px auto", textAlign: "center" }}>
        <div style={{ fontSize: 48 }}>🔒</div>
        <h2>Chức năng Thi khảo sát đang tạm khoá</h2>
        <p style={{ color: "#6b7280" }}>Hiện chỉ giáo viên và quản trị được xem. Vui lòng liên hệ quản trị khi cần xem lại.</p>
        <Link to="/happyschool">← Về trang chủ</Link>
      </div>
    );
  }
  return <HappySchoolThiKhaoSat />;
};

export default HappySchoolThiKhaoSatGate;
